export class CCTransaction {
  InvoiceID: string;
  TotalAmount: string;
  CCV: string;
  IsPayFullBalance: boolean;
}
